// Turns the live events of a conversation (from /ai-office/events) into the messages the chat shows.
// Pure functions: (messages, event) -> new messages.

const withoutTyping = (msgs) => msgs.filter((m) => m.kind !== 'typing');

export function applyChatEvent(msgs, ev) {
  switch (ev.type) {
    case 'typing':
      return [...withoutTyping(msgs), { kind: 'typing', agentId: ev.agentId }];
    case 'text': {
      const key = `${ev.runId}:${ev.segment}`;
      const base = withoutTyping(msgs);
      const i = base.findIndex((m) => m.key === key);
      if (i < 0) return [...base, { kind: 'agent', agentId: ev.agentId, key, text: ev.delta }];
      const next = base.slice();
      next[i] = { ...next[i], text: next[i].text + ev.delta };
      return next;
    }
    case 'tool_start':
      return [...withoutTyping(msgs), { kind: 'tool', key: ev.callId, label: ev.label, detail: ev.detail, state: 'run' }];
    case 'tool_end':
      return msgs.map((m) => (m.key === ev.callId ? { ...m, state: ev.ok ? 'ok' : 'fail', result: ev.ok ? null : ev.result } : m));
    case 'notice':
      return [...withoutTyping(msgs), { kind: 'sys', text: ev.text }];
    case 'error':
      return [...withoutTyping(msgs), { kind: 'sys', err: true, text: ev.text, retry: !!ev.retry }];
    case 'memory_saved':
      return [...withoutTyping(msgs), { kind: 'memory', agentId: ev.agentId, facts: [ev.fact], shared: ev.shared }, { kind: 'typing', agentId: ev.agentId }];
    case 'question':
      return [...withoutTyping(msgs), { kind: 'question', agentId: ev.agentId, key: ev.callId, question: ev.question, options: ev.options || [] }];
    case 'approval_required':
      return [...withoutTyping(msgs), { kind: 'approval', approval: ev.approval }, { kind: 'typing', agentId: ev.agentId }];
    case 'done':
      return withoutTyping(msgs).map((m) => (m.kind === 'tool' && m.state === 'run' ? { ...m, state: 'fail' } : m));
    default:
      return msgs;
  }
}

// A decided approval updates its card wherever it is shown.
export function applyApprovalUpdate(msgs, approval) {
  let hit = false;
  const next = msgs.map((m) => {
    if (m.kind === 'approval' && m.approval.id === approval.id) { hit = true; return { ...m, approval: { ...m.approval, ...approval } }; }
    return m;
  });
  return hit ? next : msgs;
}

export const CHAT_EVENTS = new Set(['typing', 'text', 'tool_start', 'tool_end', 'notice', 'error', 'done', 'approval_required', 'question', 'memory_saved']);
